// extracted by mini-css-extract-plugin
export default {"app-error":"AppError_app-error__mqPBh","error-text":"AppError_error-text__Ly0rz"};